import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStateContext } from '../../contexts/ContextProvider';

import { Toaster, toast } from 'react-hot-toast';
import Axios from '../../Axios';
import '../../App.css';

import patternImg from "../../data/emin40anno.jpg"
import logologitrack2 from '../../data/logo-azul.png';
import franjaImageUrl from '../../data/franjacolores.png';

import twitterImg from "../../data/twitter-logo.svg"

//src={sellAi}

const initialState = { usuario: '',  rutEmpresa: '79527230-5' };

export default function OlvidePassword() {
  const { setCurrentColor, setCurrentMode } = useStateContext();
  const navegate = useNavigate();
  const [errorMessage, setErrorMessage] = useState('');
  const [formData, setFormData] = useState(initialState);
  const [isSignup, setIsSignup] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false); // Nuevo estado para el checkbox
  // Colores visualmente compatibles con #2C5282
  const PRIMARY_BLUE = 'bg-blue-900'; 
  const PRIMARY_TEXT = 'text-blue-800'; 
  const ACCENT_COLOR = 'text-yellow-400';


  useEffect(() => {
    const currentThemeColor = localStorage.getItem('colorMode');
    const currentThemeMode = localStorage.getItem('themeMode');
    if (currentThemeColor && currentThemeMode) {
    setCurrentColor(currentThemeColor);
    setCurrentMode(currentThemeMode);
    }
}, []);

  const handleShowPassword = () => setShowPassword(!showPassword);

  const handleSubmit = (e) =>{
      e.preventDefault();
      setErrorMessage('');

      if (formData.usuario.length===0)
        {
          toast.error('Debe ingresar usuario');
          return false;
        }

        Axios.post('/usuario/olvidepassword', formData)
        .then(response => {
          const { data } = response;
        //  window.localStorage.setItem('codigorecuperacion', JSON.stringify( data.codigo ));
          window.localStorage.setItem('usuariorecuperacion', JSON.stringify( formData.usuario ));
          console.log('Respuesta del servidor:', JSON.stringify(data.message));
          toast.success('Código de recuperación enviado a su correo electrónico');
          navegate('/recuperarpassword');
        })
        .catch( error  => {
          console.log('Error ' + error + ' ' + error.message );
          toast.error('Usuario y/o Correo electrónico Incorrectos');
          navegate('/login');
        });


  };

  const handleChange = (e) =>{
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };


  return (

    <div className="flex flex-col min-h-screen">
      
      {/* 1. Franja Superior Azul Oscuro 
      <div className={`h-12 ${PRIMARY_BLUE} w-full`}></div>
      */}

      {/* Franja Superior Azul Oscuro con la imagen (Altura ajustada a h-16) */}
      <div className={`h-16 ${PRIMARY_BLUE} w-full flex items-center relative`}> 
        <img 
          src={franjaImageUrl} // Usamos la URL resuelta del archivo subido
          alt="Detalle de diseño de la franja superior" 
          // Posicionado a la izquierda (left-[50px]) y con altura completa (h-full)
          className="absolute left-[50px] h-full object-contain" 
        />
      </div>

      {/* Contenedor central de la caja de login - Ocupa todo el espacio restante (flex-grow) */}
      {/* Usa bg-gray-100 para un fondo sutil fuera de la caja de login */}
      <div className={`flex-grow flex justify-center items-center bg-white p-4 md:p-8`}>
        
        {/* Contenedor de la caja de login (Dos Columnas) - Ancho máximo y alto completo */}
        {/* h-full: Ocupa todo el alto disponible en el contenedor flex-grow */}
        <div className="flex w-full max-w-6xl mx-auto  overflow-hidden rounded-lg h-full bg-white"> 
        
          {/* Panel Izquierdo: Logos e Información (Oculto en md y abajo, Visible en lg y arriba) */}
          {/* hidden md:flex: Oculto en móviles, visible como flex a partir de `md` */}
          <div className={`hidden md:flex flex-col justify-between p-12 w-1/2 text-white`}>
            
            {/* Simulación del Logo EMIN */}
            <div>
              <img
              src={patternImg}
              alt="Background"
              className=" object-cover rounded-3xl  max-w-xs lg:max-w-full"
              />
            </div>

            {/* Simulación del Logo Logitrack */}
            <div className="mt-auto"> 
              <div className="flex items-center">
              <img
              src={logologitrack2}
              alt="Background"
              className=" object-cover rounded-3xl  max-w-xs lg:max-w-full"
              />
              </div>
            </div>
            
          </div>

          {/* Panel Derecho: Formulario de Login - Visible en todas las resoluciones */}
          {/* w-full md:w-1/2: Ocupa todo el ancho en móvil, la mitad en desktop */}
          <div className="w-full md:w-1/2 flex flex-col justify-center items-center p-8 md:p-12 bg-white">
            <div className="w-full max-w-sm">

              <div className="text-center mb-8">
                <h1 className="text-2xl font-semibold text-blue-900">Recuperar contraseña</h1>
                <p className="text-gray-600 mt-2 text-sm">
                  Ingrese su usuario o correo electrónico
                </p>
              </div>
              

              {/* Formulario de login */}
              <form onSubmit={handleSubmit} className="space-y-4">
                
                <div>
                  <label htmlFor="username" className="block text-xs font-medium text-gray-700 mb-1">
                    Correo electrónico o Usuario
                  </label>
                  <input
                    id="username"
                    type="text"
                    name="usuario"
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm text-sm focus:ring-blue-500 focus:border-blue-500 transition-colors"
                    required
                  />
                </div>

                <div>


                </div>

                {/* Botón de Ingresar */}
                <button
                  type="submit"
                  className={`w-full ${PRIMARY_BLUE} text-white py-3 rounded-lg font-medium 
                              hover:bg-gray-600 transition-colors mt-6`}
                >
                  Solicitar código de recuperación
                </button>
              </form>

              {/* Pie de página (Creado por) */}
              <div className="mt-8 text-center text-xs text-gray-500">
                <p>Creado por Aulanovus</p>
                <a href="https://www.aulanovus.com" className="text-gray-500 hover:underline">
                  www.aulanovus.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* 3. Franja Inferior Azul Oscuro 
      <div className={`h-12 ${PRIMARY_BLUE} w-full`}></div>
      */}

      {/* Franja Inferior Azul Oscuro con la imagen (Altura ajustada a h-16) */}
      <div className={`h-16 ${PRIMARY_BLUE} w-full flex items-center relative justify-end`}> 
        <img 
          src={franjaImageUrl} // Usamos la URL resuelta del archivo subido
          alt="Detalle de diseño de la franja inferior" 
          // Posicionado a la derecha (right-[50px]) y con altura completa (h-full)
          className="absolute right-[50px] h-full object-contain" 
        />
      </div>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            zIndex: 9999,
          },
        }}
      />    
    </div>

  );
}


